<template>
  <div class="dashboard p-4">
    <!-- end nav -->
    <div class="mt-2 w-full">
      <div
        class="lg:flex grid-cols-1 lg:space-y-0 space-y-3 gap-5 justify-between"
      >
        <div>
          <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
            Add Group
          </h1>
        </div>
      </div>
    </div>
    <div class="mt-3 mb-4">
      <Modal
        title="Add Group"
        subtitle="Fill form below"
        btnTextSubmit="Submit"
        btnType="submit"
        btnText="Add Group"
        @submitForm="createGroup(name)"
      >
        <template v-slot:body>
          <div class="space-y-5 pb-5">
            <div class="space-y-3">
              <p>Name</p>
              <input
                type="text"
                placeholder=""
                required
                class="p-2 border dark:border-gray-600 dark:bg-gray-700 w-full rounded outline-none"
                v-model="name"
              />
            </div>
          </div>
        </template>
      </Modal>
    </div>
    <div
      class="wrapper-card grid lg:grid-cols-4 grid-cols-1 md:grid-cols-2 gap-2 mt-1"
    >
      <!-- card  -->
      <div
        class="card bg-white dark:bg-gray-800 w-full rounded-md p-5 border dark:border-gray-700"
      >
        <div class="p-1 max-w-sm">
          <p class="font-semibold text-center text-gray-900 dark:text-gray-200 text-xl">
            Total Group
          </p>
          <p class="font-semibold text-center text-gray-900 dark:text-gray-200 text-xl">
           {{ dataGroups.length }}
          </p>
        </div>
      </div>
    </div>
    <!-- <div
      class="mt-2 bg-white dark:bg-gray-800 p-5 w-full rounded-md box-border border dark:border-gray-700"
    >
      <h2 class="font-bold text-lg text-gray-800 dark:text-gray-200">
        List Gruop
      </h2>
      <div class="wrapping-table mt-10">
        <table
          class="w-full text-sm text-left text-gray-500 dark:text-gray-400 lg:overflow-auto overflow-x-scroll"
        >
          <thead
            class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
          >
            <tr>
              <th
                scope="col"
                class="uppercase px-1 py-3"
              >
                No
              </th>
              <th
                scope="col"
                class="uppercase px-1 py-3"
              >
                Name Group
              </th>
              <th
                scope="col"
                class="uppercase px-6 py-3"
              >
                Total Plant
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 odd:bg-white even:bg-gray-50"
              v-for="(items, i) in temp"
            >
              <td class="px-1 py-4">
                {{ i+1 }}
              </td>
              <td class="px-1 py-4">
                Gruop {{ items }}
              </td>
              <td class="px-6 py-4">
                0
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> -->
    <div class="mt-3 w-full">
      <div
        class="lg:flex grid-cols-1 lg:space-y-0 space-y-3 gap-5 justify-between"
      >
        <div>
          <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
            List Group
          </h1>
        </div>
      </div>
    </div>
    <div v-if="dataGroups.length == 0">
      <p class="text-center text-xl mt-10 dark:text-gray-200">No Group Found</p>
    </div>
    <div v-else
      class="wrapper-card grid lg:grid-cols-5 grid-cols-2 md:grid-cols-3 gap-2 mt-1"
    >
      <routerLink
        :to="'/group/'+item.id"
        class="card bg-white dark:bg-gray-800 w-full rounded-md p-4 border dark:border-gray-700 flex hover:border-orange-500 dark:hover:border-orange-400 duration-300"
        v-for="(item) in dataGroups"
      >
        <div class="w-full" style="word-break: break-word;">
          <p class="font-semibold text-gray-900 dark:text-gray-200 text-xl">
            {{ item.name }}
          </p>
          <h2 class="font-normal text-gray-400 text-md mt-2">Plant Total</h2>
          <p class="font-semibold text-gray-900 dark:text-gray-200 text-xl">
            {{ item.plantMemberCount }}
          </p>
        </div>
      </routerLink>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { useCounterStore } from "@/store/counter";
  import { Icon } from "@iconify/vue";
  import { mapActions, mapState } from "pinia";
  import Modal from "@/components/modal.vue";

  export default {
    name: "Group",
    data() {
      return {
        name: ''
      };
    },
    components: {
      Icon, Modal
    },
    methods: {
      ...mapActions(useCounterStore,['createGroup', 'getDataGroup']),
    },
    created(){
      this.getDataGroup()
    },
    computed: {
      ...mapState(useCounterStore, ['dataGroups'])
    },
    mounted() {}
  };
</script>
